// import 'amfe-flexible';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import '@/styles/index.scss';
import { VueQueryPlugin } from "@tanstack/vue-query";
import store from './store';
import 'element-plus/dist/index.css'
import ElementPlus from 'element-plus'

store.dispatch('initAuth'); // 等待登录态初始化
const app = createApp(App);
app.use(router);
app.use(ElementPlus)
app.use(VueQueryPlugin)
app.mount('#app');
